import { Lit3formBlock, html, classMap, icon } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { isDealerPage } from '../../../helpers/helpers';
import { styleMap } from 'lit/directives/style-map.js';
import {
  adobeCleanString,
  analyticsCtaDataObject,
  handleAdobeNavEvent,
} from '../../../helpers/adobe-analytics';

export class Ralph extends Lit3formBlock {
  static get characterName() {
    return 'ralph';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
      requiresScroll: { type: Boolean },
      imagesLoaded: { type: Boolean },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  constructor() {
    super();
    this.imagesLoaded = 0;
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div
          id="ralph-block"
          class="block-grid ralph-layout"
          style="${styleMap(this.textColor)}"
        >
          <div class="ralph-header">
            <h2>${this.headerText}</h2>
            <cta-text
              cta-data=${this.ctaData}
              .ctaAnalyticsData=${analyticsCtaDataObject(
                this.ctaData,
                this.headerText
              )}
            ></cta-text>
          </div>
          ${this.requiresScroll
            ? html`
                <span
                  @click="${() => this.sideScroll('left')}"
                  class="scroll-buttons left-arrow"
                >
                  ${icon('arrow')}
                </span>
                <span
                  @click="${() => this.sideScroll('right')}"
                  class="scroll-buttons right-arrow"
                >
                  ${icon('arrow')}
                </span>
              `
            : html``}
          <div id="ralph-images" class="${classMap(this.imagesClasses)}">
            ${this.images.map(
              image =>
                html`
                  <a
                    href="${image[1].url}"
                    class="image"
                    @click="${event => {
                      const galleryName = adobeCleanString(image[1].name);
                      handleAdobeNavEvent({
                        navString: `NAV|Project Gallery Driver|${galleryName}`,
                        destinationUrl: `${image[1].url}`,
                        event,
                      });
                    }}"
                  >
                    <img
                      src=${this.imagebossUrl(image[1].src, null, '400')}
                      decoding="async"
                      @load="${this.imgLoaded}"
                    />
                    <div class="project-label">
                      <span>
                        <p>${this.projectIndustry(image[1])}</p>
                      </span>
                      <h3>
                        ${this.projectName(image[1])}
                      </h3>
                    </div>
                  </a>
                `
            )}
          </div>
        </div>
      </div>
    `;
  }

  imgLoaded() {
    this.imagesLoaded++;
    if (!this.requiresScroll) {
      // only check _horizontalScrollNeeded if requiresScroll is false
      if (this._horizontalScrollNeeded) {
        this.requiresScroll = true;
        this.requestUpdate();
      }
    }
  }

  sideScroll(direction) {
    const element = this.shadowRoot.getElementById('ralph-images');
    let scrollAmount = 0;
    const step = 40;
    const distance = 700;
    const slideTimer = setInterval(function() {
      direction === 'left'
        ? (element.scrollLeft -= step)
        : (element.scrollLeft += step);
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, 10);
  }

  get imagesClasses() {
    const classes = {
      images: true,
    };
    classes['scrollable'] = this.requiresScroll;
    return classes;
  }

  projectIndustry(project) {
    return project.industry;
  }

  projectName(project) {
    return project.name;
  }

  get headerText() {
    return !!this.content.header ? this.content.header : 'Project Inspiration';
  }

  get ctaText() {
    return this.content.cta && this.content.cta.text
      ? this.content.cta.text
      : 'See More';
  }

  get ctaUrl() {
    return this.content.cta && this.content.cta.url
      ? this.content.cta.url
      : '/gallery';
  }

  get _ralphBlockWidth() {
    return this.shadowRoot.getElementById('ralph-block').scrollWidth;
  }

  get _ralphImagesWidth() {
    return this.shadowRoot.getElementById('ralph-images').scrollWidth;
  }

  get _horizontalScrollNeeded() {
    return this._ralphImagesWidth > this._ralphBlockWidth;
  }

  get images() {
    return this.content.images || [];
  }

  imageDescription(image) {
    return this.withLineBreaks(image.description);
  }

  get ctaData() {
    const cta = {
      text: this.ctaText,
      url: this.ctaUrl,
      useWhite: true,
    };
    return JSON.stringify(cta);
  }

  // Ralph's default canvas is dark, so it carries its own light type; a CMS
  // text color still wins.
  get textColor() {
    return {
      color: isDealerPage()
        ? 'var(--block-text-color, #222222)'
        : 'var(--block-text-color, #ffffff)',
    };
  }
}
Ralph.defineElement();
